module.exports = __webpack_public_path__ + "img/money.2b4b0bc3.png";